import React, { useLayoutEffect } from 'react';
import { useI18n } from '../../../../i18n';
import S from './components/style/Dac7Layout';
import Style from './style/Dac7ContentSuccess';

import Dac7InfoCard from './Dac7InfoCard';
import DocumentIcon from './assets/document.svg';
import SearchAvatarIcon from './assets/search-avatar.svg';

const SuccessContent = () => {
  const i18n = useI18n();
  return (
    <Style.Dac7ContentSuccessContainer>
      <Style.H1>{i18n('dlv_dac7_success_title')}</Style.H1>
      <Style.H4>{i18n('dlv_dac7_success_subtitle')}</Style.H4>

      <Style.StepsContainer>
        {/* ---------------------- Step 1 ---------------------- */}
        <Style.StepContainer>
          <Style.IconWrapper>
            <DocumentIcon />
          </Style.IconWrapper>
          <Style.StepInfoContainer>
            <Style.P2>{i18n('dlv_dac7_success_step1_title')}</Style.P2>
            <Style.P3>{i18n('dlv_dac7_success_step1_description')}</Style.P3>
          </Style.StepInfoContainer>
        </Style.StepContainer>

        {/* ---------------------- Step 2 ---------------------- */}
        <Style.StepContainer>
          <Style.IconWrapper>
            <SearchAvatarIcon />
          </Style.IconWrapper>
          <Style.StepInfoContainer>
            <Style.P2>{i18n('dlv_dac7_success_step2_title')}</Style.P2>
            <Style.P3>{i18n('dlv_dac7_success_step2_description')}</Style.P3>
          </Style.StepInfoContainer>
        </Style.StepContainer>
      </Style.StepsContainer>
    </Style.Dac7ContentSuccessContainer>
  );
};

const DAC7ContentSuccess = () => {
  const i18n = useI18n();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <S.LayoutContainer>
      <S.LowerLayer>
        <S.StartContainerWrapper>
          <SuccessContent />
          <S.CTALayer>
            <Style.CTAContainer>
              <Style.SButtonPrimaryDark link="https://www.olx.pl/myaccount/profile/">
                {i18n('dlv_dac7_go_back_to_profile_button')}
              </Style.SButtonPrimaryDark>
            </Style.CTAContainer>
          </S.CTALayer>
        </S.StartContainerWrapper>
        <S.EndContainer>
          <Dac7InfoCard />
        </S.EndContainer>
      </S.LowerLayer>
    </S.LayoutContainer>
  );
};

export default DAC7ContentSuccess;
